export default function returnDate(d) {
  const date = new Date(d);
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  const yyyy = date.getFullYear();
  dd = dd < 10 ? `0${dd}` : dd;
  mm = mm < 10 ? `0${mm}` : mm;
  return `${dd}/${mm}/${yyyy}`;
}

export function fullDateWithDetails(inputDate) {
  let date;
  if (inputDate) date = new Date(inputDate);
  else date = new Date();
  return date.toLocaleString("en-GB", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}
